<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('trigger-mailings') }} -> {{ $t('list-trigger-mailing') }}
    </h1>
    <div class="main__body">
      <p class="gray-about">{{ $t('list-trigger-mailing-about-1') }}<br>
        {{ $t('list-trigger-mailing-about-2') }}</p>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('active') }}</th>
          <th scope="col">{{ $t('name-triggers') }}</th>
          <th scope="col">{{ $t('count-sending') }}</th>
          <th scope="col">{{ $t('count-clients') }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in triggerMessages" v-bind:key="item.id">
          <th scope="row">
            {{ index + 1}}
          </th>
          <th scope="row">
            <label class="table__selected">
              <input type="checkbox" :checked="parseInt(item.active)" @click="setActiveTrigger(item.id)">
              <span class="checkmark"></span>
            </label>
          </th>
          <td>{{ item.name }}</td>
          <td>{{ item.countSend }}</td>
          <td>{{ item.countClient }}</td>
          <td class="pointer" v-if="item.countSend > 0"><img src="@/assets/icon/view.svg" @click="openHistory(item.id)"></td>
          <td v-else><img src="@/assets/icon/view.svg"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from "vue-loading-overlay";
import clientInSegmentModal from "../components/modal/clientInSegmentModal";

export default {
  name: 'listTriggerMailing',
  data: function () {
    return {
      triggerMessages: [],
      isLoading: false,
      fullPage: true,
    }
  },
  created: function () {
    this.getTriggerMessages();
  },
  methods: {
    openHistory: function (id){
        this.$router.push({
          path: `/history-trigger-message/${id}`
      });
    },
    getTriggerMessages: function () {
      this.isLoading = true;
      axios.post('getTriggerMessages').then(response => {
        var status = response.data.status;
        if (status) {
          this.triggerMessages = response.data.triggerMessages;
          this.isLoading = false;
        }
      });
    },
    setActiveTrigger: function(id){
      this.isLoading = true;
      var data = {
        user_id: this.$store.getters.user,
        trigger_id: id
      }
      axios.post('setActiveTrigger', data).then(response => {
        var status = response.data.status;
        if(status){
          this.getTriggerMessages();
          this.isLoading = false;
        }
      });
    },
  },
  components: {
    loading, clientInSegmentModal
  }
}
</script>